import { useContext } from 'react';
import { format } from '../../../../../helpers/formatter';
import { useInfoSync } from '../../../../../Hooks/useInfoSync';
import { Articulo } from '../../../../Productos/Articulo';
import { ButtonsActionsCart } from '../../ButtonsActionsCart/ButtonsActionsCart';
import { UserContext } from '../../../../auth/context/UserContext';

export const ProductCard = ({
  // articulo,
  // stockUnitario,
  // showActions,
  // precios,
  // priceToDisplay,
  // moneda,
  articulo,
  stockUnitario,
  showActions,
  precios,
  priceToDisplay,
}) => {
  const { sinonimo, codigo_mg, descripcion_2 } = articulo;

  const { data: dataInfoSync } = useInfoSync();
  const monedaData = dataInfoSync?.moneda_carrito || 0;

  const { dataUser } = useContext(UserContext);
  const userData = dataUser;

  const visualizaStock = userData.visualizaStock;
  return (
    <div id="catalogo" className="itemcuad">
      <div className="buttons-actions-carts-content f-c g-8">
        <Articulo articulo={articulo} />
        <small style={{ textAlign: 'left', fontSize: '12px' }}>
          {descripcion_2}
        </small>
        <ul className="catalog-grid-content-detail">
          <li>
            <span>Código: </span>
            <span>{codigo_mg}</span>
          </li>
          <li>
            <span>Sinónimo: </span>
            <span>{sinonimo}</span>
          </li>
          <li style={!visualizaStock ? { display: 'none' } : undefined}>
            <span className="stock-producto">
              <strong>{stockUnitario || 0} </strong> unidades
            </span>
            <span className="precio-producto">
              {format.currency(monedaData, priceToDisplay) || 0}
            </span>
          </li>
        </ul>
      </div>
      {showActions && (
        <div className="actions-bottom">
          <ButtonsActionsCart articulo={articulo} precios={precios} />
        </div>
      )}
    </div>
  );
};
